import { Space, Tag } from 'antd';
import { RevxTable } from 'components';
import { RevxButton } from 'components/RevxButton';
import { TableColumnsType } from 'components/RevxTable';
import { DaysOfWeekEnum, GenericSchedule, RoundUpEnum } from 'domains/tfDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';

type TfTableProps = {
  data: GenericSchedule[];
  onItemView: (item: GenericSchedule) => void;
};

const TfTable = (props: TfTableProps) => {
  const { t } = useTranslation();
  const rangeDateRender = function (value: any, record: GenericSchedule) {
    if (record.ongoing) {
      return t('platform.tf.labels.allDays');
    } else {
      return value;
    }
  };
  const dowRender = function (value: DaysOfWeekEnum[]) {
    const dowSet = new Set<DaysOfWeekEnum>(value);
    return (
      <div className="ant-radio-group ant-radio-group-solid">
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.SUNDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>S</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.MONDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>M</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.TUESDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>T</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.WEDNESDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>W</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.THURSDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>T</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.FRIDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>F</span>
        </label>
        <label
          className={`
        ant-radio-button-wrapper 
        ${
          dowSet.has(DaysOfWeekEnum.SATURDAY)
            ? 'ant-radio-button-wrapper-checked'
            : ''
        }`}
        >
          <span>S</span>
        </label>
      </div>
    );
  };

  const roundupRender = function (value: RoundUpEnum) {
    switch (value) {
      case RoundUpEnum.ADD_A_DAY:
        return t('platform.tf.labels.addDay');
      case RoundUpEnum.NO_ROUNDING:
        return t('platform.tf.labels.noRounding');
      case RoundUpEnum.TO_COMPLETE_DAY:
        return t('platform.tf.labels.toCompleteDay');
      case RoundUpEnum.TO_NEXT_HALF_DAY:
        return t('platform.tf.labels.toNextHalfDay');
      default:
        return '';
    }
  };

  const columns: TableColumnsType<GenericSchedule> = [
    {
      title: t('common.id'),
      dataIndex: 'id',
      fixed: 'left',
    },
    {
      title: t('common.name'),
      dataIndex: 'name',
    },
    {
      title: t('platform.tf.columns.shiftsPerDay'),
      dataIndex: 'shiftsPerDay',
    },
    {
      title: t('platform.tf.columns.hoursPerShift'),
      dataIndex: 'hoursPerShift',
    },
    {
      title: t('platform.tf.columns.utilizationPct'),
      dataIndex: 'utilizationPct',
    },
    {
      title: t('platform.tf.columns.daysOfWeek'),
      dataIndex: 'daysOfWeek',
      render: dowRender,
    },
    {
      title: t('platform.tf.columns.dateRange'),
      children: [
        {
          title: t('platform.markup.columns.startDate'),
          dataIndex: 'startDate',
          render: rangeDateRender,
        },
        {
          title: t('platform.markup.columns.endDate'),
          dataIndex: 'endDate',
          render: rangeDateRender,
        },
      ],
    },
    {
      title: t('platform.tf.columns.roundUp'),
      dataIndex: 'roundup',
      render: roundupRender,
    },
    {
      title: t('common.active'),
      fixed: 'right',
      dataIndex: 'active',
      render: (active) => (
        <Tag color={active ? 'green' : 'volcano'}>
          {active ? t('common.active') : t('common.inactive')}
        </Tag>
      ),
    },
    {
      title: t('common.actions'),
      key: 'actions',
      fixed: 'right',
      render: (value, record) => (
        <Space size="small">
          <RevxButton
            type="link"
            key="view"
            onClick={() => props.onItemView(record)}
          >
            {t('common.view')}
          </RevxButton>
        </Space>
      ),
    },
  ];

  return <RevxTable columns={columns} dataSource={props.data} />;
};

export default TfTable;
